module.exports = __webpack_public_path__ + "img/qrcode.35fd610c.svg";